import React from "react";
import { Navbar, Container, Nav } from "react-bootstrap";

function NavigationBar() {
    return (
        <Navbar bg="secondary" variant="dark" collapseOnSelect expand="sm">
            <Container>
                <Navbar.Brand href="/">Ryan's Upholstery</Navbar.Brand>
                <Navbar.Toggle aria-controls='responsive-navbar-nav' />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="/">Home</Nav.Link>
                        <Nav.Link href="/contact">Contact</Nav.Link>
                        <Nav.Link href="/quote">Quote</Nav.Link>
                        <Nav.Link href="/photos">Photos</Nav.Link>
                        <Nav.Link href="/reviews">Reviews</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
                
            </Container>
      </Navbar>
    )
}

export default NavigationBar
